import { metrics } from '@atlassian/browser-metrics/factory';
import type { Metric } from '@atlassian/browser-metrics/metric';

export const createLegacyIssueInteraction = (key: string): Metric => metrics.interaction({ key });
